import { orderBy } from 'lodash-es'

export const orderAlphabetically = content => {
  return orderBy(content, ['name'])
}
